import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { SafetyMessageAndLogoActionTypes } from 'types';
import Services from '../../services';
import {
  updateSafetyMessageAndLogoFailure,
  updateSafetyMessageAndLogoSuccess
} from './actions';
import { fetchAppFailure } from 'redux/app/actions';
import _ from 'lodash';

function* doUpdateSafetyMessageAndLogo(request: any) {
  const getSession = (state: any) => state.session;
  const session = yield select(getSession);
  if (session.isAuthenticated) {
    try {
      const data = request.payload;

      const uploadPayload = {
        name: data.payload?.logo?.name,
        mimeType: data?.payload?.logo?.type,
        entityId: data.organisationId,
        entity: 'Organisation'
      };

      let logoId: any = null;

      if (
        !_.isUndefined(data.payload.logo) &&
        data.payload.logo instanceof File
      ) {
        const upload = yield call(
          Services.areaOfInterest.getNewUploadLocation,
          uploadPayload
        );

        if (!upload.url) {
          return yield put(
            updateSafetyMessageAndLogoFailure('Unable to get upload location.')
          );
        }
        logoId = upload?.id;
        const uploadToS3 = yield call(
          Services.safetyMessageAndLogo.uploadDirectToS3,
          upload.url,
          data.payload?.logo
        );
        if (!uploadToS3.ok) {
          return yield put(
            updateSafetyMessageAndLogoFailure('Unable to get upload to S3')
          );
        }
      }

      const updateSafetyMessageAndLogoPayload: any = {
        organisationId: data.organisationId,
        payload: {
          safetyMessage: data.payload?.safetyMessage,
          logoId: logoId,
          isDeleteLogo: data.payload?.isDelete
        }
      };

      const response = yield call(
        Services.member.updateOrganisationProfile,
        updateSafetyMessageAndLogoPayload
      );
      if (!response.error) {
        yield put(updateSafetyMessageAndLogoSuccess(response));
      } else {
        yield put(updateSafetyMessageAndLogoFailure(response.error.message));
      }
    } catch (error) {
      const response = {
        error: {
          message: 'Internal Server Error.',
          type: 'unique violation',
          code: 401
        }
      };
      yield put(updateSafetyMessageAndLogoFailure(response.error.message));
      yield put(fetchAppFailure(response.error.message));
    }
  }
}

export function* onUpdateSafetyMessageAndLogo() {
  yield takeLatest(
    SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_START,
    doUpdateSafetyMessageAndLogo
  );
}

function* safetyMessageAndLogoSagas() {
  yield all([call(onUpdateSafetyMessageAndLogo)]);
}
export default safetyMessageAndLogoSagas;
